import { render, staticRenderFns } from "./GjwCheckboxGroup.vue?vue&type=template&id=b2a66b6a&scoped=true&"
import script from "./GjwCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./GjwCheckboxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a66b6a",
  null
  
)

export default component.exports